import { Controller } from "@hotwired/stimulus"

// Masque l'élément quand l'URL porte une ancre #assembly-N qui ne correspond
// ni à `id` (un montage) ni à l'une des `ids` (un article complémentaire
// pouvant appartenir à plusieurs montages).
export default class extends Controller {
  static values = { id: String, ids: Array }

  connect() {
    if (!window.location.hash) return

    const currentHash = window.location.hash.slice(1) // Remove the '#'
    const expectedHashes = [this.idValue, ...this.idsValue]

    if (!expectedHashes.includes(currentHash)) {
      this.element.classList.add("hidden")
    }
  }
}
